import React from 'react';
import { FileSpreadsheet } from 'lucide-react';
import { PrimaryButton, SecondaryButton } from 'src/shared/components/button/Button';

type ManifestStepProps = {
    onDownload: () => void;
    onFinish: () => void;
};

const ManifestStep = ({ onDownload, onFinish }: ManifestStepProps) => {
    return (
        <div className='flex flex-col items-center gap-6'>
            <div className='flex items-center justify-center w-20 h-20 rounded-full bg-grey-20'>
                <FileSpreadsheet className='w-10 h-10 text-primary' />
            </div>
            <div className='flex flex-col items-center gap-2 max-w-md text-center'>
                <h2 className='text-2xl font-semibold text-primary'>Site Manifest</h2>
                <p className='text-base text-grey-70'>
                    Download a CSV spreadsheet to add sites manually. You can fill in site names, locations and other details, then import
                    the manifest later.
                </p>
            </div>
            <div className='flex items-center gap-3'>
                <PrimaryButton onClick={onDownload} data-testid='wizard-download-button'>
                    Download Manifest
                </PrimaryButton>
                <SecondaryButton onClick={onFinish} data-testid='wizard-finish-button'>
                    Finish Setup
                </SecondaryButton>
            </div>
        </div>
    );
};

export default ManifestStep;
